<article class="ba-content-article">
    <header class="ba-content-header">
        <h1 id="kbs_Header_txt">Online-Dialog Bezügestellen</h1>
    </header>
    <section>
        <div class="alert alert-error">
            <p class="alert-header" id="kbs_fehlerTitle_txt">Fehlende Berechtigung</p>
            <p id="kbs_fehlerText_txt">
                Sie haben keine Berechtigung, um den Online-Dialog-Bezügestellen zu verwenden. Bei Fragen können Sie
                sich gerne an die Ansprechpartner Ihrer regionalen Familienkasse wenden.
            </p>
        </div>
    </section>
</article>
